import React from "react";
import { TableBody } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { format } from "date-fns";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button, DivPaper, Icon, Text, Files, Heading } from "src/components";
import { FileStore, UserStore, RootStore } from "src/stores";
import styled from "styled-components";
import { FeedbackType, FileData, FileType } from "src/types";
import { File } from "src/models";
import { Row } from "./editData/gridElements";

export interface IDocumentsProps {
  fileStore?: FileStore;
  userStore?: UserStore;
  rootStore?: RootStore;
}

export const Documents = inject(
  "fileStore",
  "userStore",
  "rootStore",
)(
  observer((props: IDocumentsProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    const { fileStore, userStore, rootStore } = props;

    return (
      <StyledDivPaper
        style         = {{ maxWidth: "115rem", marginLeft: '2rem', padding: 0 }}
        justifyContent="center"
        $center
        $noShadow
      >
        <Row style={{ padding: "2rem 2rem", flexDirection: 'column' }} height="fit-content" width="100%">
          <Heading type="h3">{t("documents")}</Heading>
          {rootStore.authStore.getCurUser.canEdit && (
            <Files
              files={[]} // list is below
              type={FileType.Document}
              onUpload={(f) => fileStore.addFileToRoom(f)}
              onDelete={(f) => fileStore.removeFileFromRoom(f)}
              alignUpload='bottom'
              hideHeading
            />
          )}
        </Row>

        <StyledTable>
          <TableHead>
            <TableRow>
              {[t("file_name"), t("type"), t("date"), t("uploaded_by"), t('view')].map(
                (header: string) => (
                  <TableCell style={{ padding: "3rem 2rem" }} key={header}>
                    <Text weight="bold" size="large">{header}</Text>
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {fileStore.getItems.map((i) => {
              const item = rootStore.getItemById(i.item_id);
              return (
                <TableRow key={i.id}>
                  <TableCell>
                    <IconWrapper>
                      <Icon size="medium" iconId={i.mime === "image/jpeg" ? "image" : "file"} />
                      <Text style={{ marginLeft: "1rem" }}>{i.title}</Text>
                    </IconWrapper>
                  </TableCell>
                  <TableCell>
                    <Text>{i.mime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{format(i.created_at, "MM/dd/yyyy")}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{userStore.getItemByID(i.created_by)?.getFullName || "not available"}</Text>
                  </TableCell>
                  <TableCell>
                    <Button variant="icon" onClick={() => i.openInWindow()}>
                      <Icon size="large" iconId="eye" />
                    </Button>
                  </TableCell>
                </TableRow>
              )
            }
            )}
          </TableBody>
        </StyledTable>
      </StyledDivPaper>
    );
  })
);

const IconWrapper = styled.div`
  align-items:    center;
  display:        flex;
  flex-direction: row;
`

const StyledDivPaper = styled(DivPaper)`
  margin-top: 10vh;
  padding:    0;
  width:      100rem;
`;

const StyledTable = styled(Table)`
  :last-of-type {
    td {
      border-bottom: none;
      border-top:    1px solid rgba(224, 224, 224, 1);
    }
  }
`;
